const countriesObj = {
  "United States": {
    "states": [{
      "name": "Armed Forces Americas"
    }, {
      "name": "Armed Forces Europe"
    }, {
      "name": "Alaska"
    }, {
      "name": "Alabama"
    }, {
      "name": "Armed Forces Pacific"
    }, {
      "name": "Arkansas"
    }, {
      "name": "American Samoa"
    }, {
      "name": "Arizona"
    }, {
      "name": "California"
    }, {
      "name": "Colorado"
    }, {
      "name": "Connecticut"
    }, {
      "name": "District of Columbia"
    }, {
      "name": "Delaware"
    }, {
      "name": "Florida"
    }, {
      "name": "Federated Micronesia"
    }, {
      "name": "Georgia"
    }, {
      "name": "Guam"
    }, {
      "name": "Hawaii"
    }, {
      "name": "Iowa"
    }, {
      "name": "Idaho"
    }, {
      "name": "Illinois"
    }, {
      "name": "Indiana"
    }, {
      "name": "Kansas"
    }, {
      "name": "Kentucky"
    }, {
      "name": "Louisiana"
    }, {
      "name": "Massachusetts"
    }, {
      "name": "Maryland"
    }, {
      "name": "Maine"
    }, {
      "name": "Marshall Islands"
    }, {
      "name": "Michigan"
    }, {
      "name": "Minnesota"
    }, {
      "name": "Missouri"
    }, {
      "name": "Northern Mariana Islands"
    }, {
      "name": "Mississippi"
    }, {
      "name": "Montana"
    }, {
      "name": "North Carolina"
    }, {
      "name": "North Dakota"
    }, {
      "name": "Nebraska"
    }, {
      "name": "New Hampshire"
    }, {
      "name": "New Jersey"
    }, {
      "name": "New Mexico"
    }, {
      "name": "Nevada"
    }, {
      "name": "New York"
    }, {
      "name": "Ohio"
    }, {
      "name": "Oklahoma"
    }, {
      "name": "Oregon"
    }, {
      "name": "Pennsylvania"
    }, {
      "name": "Puerto Rico"
    }, {
      "name": "Palau"
    }, {
      "name": "Rhode Island"
    }, {
      "name": "South Carolina"
    }, {
      "name": "South Dakota"
    }, {
      "name": "Tennessee"
    }, {
      "name": "Texas"
    }, {
      "name": "United States Minor Outlying Islands"
    }, {
      "name": "Utah"
    }, {
      "name": "Virginia"
    }, {
      "name": "US Virgin Islands"
    }, {
      "name": "Vermont"
    }, {
      "name": "Washington"
    }, {
      "name": "Wisconsin"
    }, {
      "name": "West Virginia"
    }, {
      "name": "Wyoming"
    }],
    "name": "United States"
  },
  "Afghanistan": {
    "states": [],
    "name": "Afghanistan"
  },
  "Aland Islands": {
    "states": [],
    "name": "Aland Islands"
  },
  "Albania": {
    "states": [],
    "name": "Albania"
  },
  "Algeria": {
    "states": [],
    "name": "Algeria"
  },
  "Andorra": {
    "states": [],
    "name": "Andorra"
  },
  "Angola": {
    "states": [],
    "name": "Angola"
  },
  "Anguilla": {
    "states": [],
    "name": "Anguilla"
  },
  "Antarctica": {
    "states": [],
    "name": "Antarctica"
  },
  "Antigua and Barbuda": {
    "states": [],
    "name": "Antigua and Barbuda"
  },
  "Argentina": {
    "states": [],
    "name": "Argentina"
  },
  "Armenia": {
    "states": [],
    "name": "Armenia"
  },
  "Aruba": {
    "states": [],
    "name": "Aruba"
  },
  "Australia": {
    "states": [{
      "name": "Australian Capital Territory"
    }, {
      "name": "New South Wales"
    }, {
      "name": "Northern Territory"
    }, {
      "name": "Queensland"
    }, {
      "name": "South Australia"
    }, {
      "name": "Tasmania"
    }, {
      "name": "Victoria"
    }, {
      "name": "Western Australia"
    }],
    "name": "Australia"
  },
  "Austria": {
    "states": [],
    "name": "Austria"
  },
  "Azerbaijan": {
    "states": [],
    "name": "Azerbaijan"
  },
  "Bahamas": {
    "states": [],
    "name": "Bahamas"
  },
  "Bahrain": {
    "states": [],
    "name": "Bahrain"
  },
  "Bangladesh": {
    "states": [],
    "name": "Bangladesh"
  },
  "Barbados": {
    "states": [],
    "name": "Barbados"
  },
  "Belarus": {
    "states": [],
    "name": "Belarus"
  },
  "Belgium": {
    "states": [],
    "name": "Belgium"
  },
  "Belize": {
    "states": [],
    "name": "Belize"
  },
  "Benin": {
    "states": [],
    "name": "Benin"
  },
  "Bermuda": {
    "states": [],
    "name": "Bermuda"
  },
  "Bhutan": {
    "states": [],
    "name": "Bhutan"
  },
  "Bolivia, Plurinational State of": {
    "states": [],
    "name": "Bolivia, Plurinational State of"
  },
  "Bonaire, Sint Eustatius and Saba": {
    "states": [],
    "name": "Bonaire, Sint Eustatius and Saba"
  },
  "Bosnia and Herzegovina": {
    "states": [],
    "name": "Bosnia and Herzegovina"
  },
  "Botswana": {
    "states": [],
    "name": "Botswana"
  },
  "Bouvet Island": {
    "states": [],
    "name": "Bouvet Island"
  },
  "Brazil": {
    "states": [{
      "name": "Acre"
    }, {
      "name": "Alagoas"
    }, {
      "name": "Amazonas"
    }, {
      "name": "Amap\u00e1"
    }, {
      "name": "Bahia"
    }, {
      "name": "Cear\u00e1"
    }, {
      "name": "Distrito Federal"
    }, {
      "name": "Esp\u00edrito Santo"
    }, {
      "name": "Goi\u00e1s"
    }, {
      "name": "Maranh\u00e3o"
    }, {
      "name": "Minas Gerais"
    }, {
      "name": "Mato Grosso do Sul"
    }, {
      "name": "Mato Grosso"
    }, {
      "name": "Par\u00e1"
    }, {
      "name": "Para\u00edba"
    }, {
      "name": "Pernambuco"
    }, {
      "name": "Piau\u00ed"
    }, {
      "name": "Paran\u00e1"
    }, {
      "name": "Rio de Janeiro"
    }, {
      "name": "Rio Grande do Norte"
    }, {
      "name": "Rond\u00f4nia"
    }, {
      "name": "Roraima"
    }, {
      "name": "Rio Grande do Sul"
    }, {
      "name": "Santa Catarina"
    }, {
      "name": "Sergipe"
    }, {
      "name": "S\u00e3o Paulo"
    }, {
      "name": "Tocantins"
    }],
    "name": "Brazil"
  },
  "British Indian Ocean Territory": {
    "states": [],
    "name": "British Indian Ocean Territory"
  },
  "Brunei Darussalam": {
    "states": [],
    "name": "Brunei Darussalam"
  },
  "Bulgaria": {
    "states": [],
    "name": "Bulgaria"
  },
  "Burkina Faso": {
    "states": [],
    "name": "Burkina Faso"
  },
  "Burundi": {
    "states": [],
    "name": "Burundi"
  },
  "Cambodia": {
    "states": [],
    "name": "Cambodia"
  },
  "Cameroon": {
    "states": [],
    "name": "Cameroon"
  },
  "Canada": {
    "states": [{
      "name": "Alberta"
    }, {
      "name": "British Columbia"
    }, {
      "name": "Manitoba"
    }, {
      "name": "New Brunswick"
    }, {
      "name": "Newfoundland and Labrador"
    }, {
      "name": "Nova Scotia"
    }, {
      "name": "Northwest Territories"
    }, {
      "name": "Nunavut"
    }, {
      "name": "Ontario"
    }, {
      "name": "Prince Edward Island"
    }, {
      "name": "Quebec"
    }, {
      "name": "Saskatchewan"
    }, {
      "name": "Yukon Territories"
    }],
    "name": "Canada"
  },
  "Cape Verde": {
    "states": [],
    "name": "Cape Verde"
  },
  "Cayman Islands": {
    "states": [],
    "name": "Cayman Islands"
  },
  "Central African Republic": {
    "states": [],
    "name": "Central African Republic"
  },
  "Chad": {
    "states": [],
    "name": "Chad"
  },
  "Chile": {
    "states": [],
    "name": "Chile"
  },
  "China": {
    "states": [{
      "name": "Beijing"
    }, {
      "name": "Tianjin"
    }, {
      "name": "Hebei"
    }, {
      "name": "Shanxi"
    }, {
      "name": "Nei Mongol"
    }, {
      "name": "Liaoning"
    }, {
      "name": "Jilin"
    }, {
      "name": "Heilongjiang"
    }, {
      "name": "Shanghai"
    }, {
      "name": "Jiangsu"
    }, {
      "name": "Zhejiang"
    }, {
      "name": "Anhui"
    }, {
      "name": "Fujian"
    }, {
      "name": "Jiangxi"
    }, {
      "name": "Shandong"
    }, {
      "name": "Henan"
    }, {
      "name": "Hubei"
    }, {
      "name": "Hunan"
    }, {
      "name": "Guangdong"
    }, {
      "name": "Guangxi"
    }, {
      "name": "Hainan"
    }, {
      "name": "Chongqing"
    }, {
      "name": "Sichuan"
    }, {
      "name": "Guizhou"
    }, {
      "name": "Yunnan"
    }, {
      "name": "Xizang"
    }, {
      "name": "Shaanxi"
    }, {
      "name": "Gansu"
    }, {
      "name": "Qinghai"
    }, {
      "name": "Ningxia"
    }, {
      "name": "Xinjiang"
    }, {
      "name": "Taiwan"
    }, {
      "name": "Hong Kong"
    }, {
      "name": "Macao"
    }],
    "name": "China"
  },
  "Christmas Island": {
    "states": [],
    "name": "Christmas Island"
  },
  "Cocos (Keeling) Islands": {
    "states": [],
    "name": "Cocos (Keeling) Islands"
  },
  "Colombia": {
    "states": [],
    "name": "Colombia"
  },
  "Comoros": {
    "states": [],
    "name": "Comoros"
  },
  "Congo": {
    "states": [],
    "name": "Congo"
  },
  "Congo, the Democratic Republic of the": {
    "states": [],
    "name": "Congo, the Democratic Republic of the"
  },
  "Cook Islands": {
    "states": [],
    "name": "Cook Islands"
  },
  "Costa Rica": {
    "states": [],
    "name": "Costa Rica"
  },
  "Cote d'Ivoire": {
    "states": [],
    "name": "Cote d'Ivoire"
  },
  "Croatia": {
    "states": [],
    "name": "Croatia"
  },
  "Cuba": {
    "states": [],
    "name": "Cuba"
  },
  "Cura\u00e7ao": {
    "states": [],
    "name": "Cura\u00e7ao"
  },
  "Cyprus": {
    "states": [],
    "name": "Cyprus"
  },
  "Czech Republic": {
    "states": [],
    "name": "Czech Republic"
  },
  "Denmark": {
    "states": [],
    "name": "Denmark"
  },
  "Djibouti": {
    "states": [],
    "name": "Djibouti"
  },
  "Dominica": {
    "states": [],
    "name": "Dominica"
  },
  "Dominican Republic": {
    "states": [],
    "name": "Dominican Republic"
  },
  "Ecuador": {
    "states": [],
    "name": "Ecuador"
  },
  "Egypt": {
    "states": [],
    "name": "Egypt"
  },
  "El Salvador": {
    "states": [],
    "name": "El Salvador"
  },
  "Equatorial Guinea": {
    "states": [],
    "name": "Equatorial Guinea"
  },
  "Eritrea": {
    "states": [],
    "name": "Eritrea"
  },
  "Estonia": {
    "states": [],
    "name": "Estonia"
  },
  "Ethiopia": {
    "states": [],
    "name": "Ethiopia"
  },
  "Falkland Islands (Malvinas)": {
    "states": [],
    "name": "Falkland Islands (Malvinas)"
  },
  "Faroe Islands": {
    "states": [],
    "name": "Faroe Islands"
  },
  "Fiji": {
    "states": [],
    "name": "Fiji"
  },
  "Finland": {
    "states": [],
    "name": "Finland"
  },
  "France": {
    "states": [],
    "name": "France"
  },
  "French Guiana": {
    "states": [],
    "name": "French Guiana"
  },
  "French Polynesia": {
    "states": [],
    "name": "French Polynesia"
  },
  "French Southern Territories": {
    "states": [],
    "name": "French Southern Territories"
  },
  "Gabon": {
    "states": [],
    "name": "Gabon"
  },
  "Gambia": {
    "states": [],
    "name": "Gambia"
  },
  "Georgia": {
    "states": [],
    "name": "Georgia"
  },
  "Germany": {
    "states": [],
    "name": "Germany"
  },
  "Ghana": {
    "states": [],
    "name": "Ghana"
  },
  "Gibraltar": {
    "states": [],
    "name": "Gibraltar"
  },
  "Greece": {
    "states": [],
    "name": "Greece"
  },
  "Greenland": {
    "states": [],
    "name": "Greenland"
  },
  "Grenada": {
    "states": [],
    "name": "Grenada"
  },
  "Guadeloupe": {
    "states": [],
    "name": "Guadeloupe"
  },
  "Guatemala": {
    "states": [],
    "name": "Guatemala"
  },
  "Guernsey": {
    "states": [],
    "name": "Guernsey"
  },
  "Guinea": {
    "states": [],
    "name": "Guinea"
  },
  "Guinea-Bissau": {
    "states": [],
    "name": "Guinea-Bissau"
  },
  "Guyana": {
    "states": [],
    "name": "Guyana"
  },
  "Haiti": {
    "states": [],
    "name": "Haiti"
  },
  "Heard Island and McDonald Islands": {
    "states": [],
    "name": "Heard Island and McDonald Islands"
  },
  "Holy See (Vatican City State)": {
    "states": [],
    "name": "Holy See (Vatican City State)"
  },
  "Honduras": {
    "states": [],
    "name": "Honduras"
  },
  "Hungary": {
    "states": [],
    "name": "Hungary"
  },
  "Iceland": {
    "states": [],
    "name": "Iceland"
  },
  "India": {
    "states": [{
      "name": "Andaman and Nicobar Islands"
    }, {
      "name": "Andhra Pradesh"
    }, {
      "name": "Arunachal Pradesh"
    }, {
      "name": "Assam"
    }, {
      "name": "Bihar"
    }, {
      "name": "Chandigarh"
    }, {
      "name": "Chhattisgarh"
    }, {
      "name": "Daman and Diu"
    }, {
      "name": "Delhi"
    }, {
      "name": "Dadra and Nagar Haveli"
    }, {
      "name": "Goa"
    }, {
      "name": "Gujarat"
    }, {
      "name": "Himachal Pradesh"
    }, {
      "name": "Haryana"
    }, {
      "name": "Jharkhand"
    }, {
      "name": "Jammu and Kashmir"
    }, {
      "name": "Karnataka"
    }, {
      "name": "Kerala"
    }, {
      "name": "Lakshadweep"
    }, {
      "name": "Maharashtra"
    }, {
      "name": "Meghalaya"
    }, {
      "name": "Manipur"
    }, {
      "name": "Madhya Pradesh"
    }, {
      "name": "Mizoram"
    }, {
      "name": "Nagaland"
    }, {
      "name": "Odisha"
    }, {
      "name": "Punjab"
    }, {
      "name": "Puducherry"
    }, {
      "name": "Rajasthan"
    }, {
      "name": "Sikkim"
    }, {
      "name": "Tamil Nadu"
    }, {
      "name": "Tripura"
    }, {
      "name": "Uttar Pradesh"
    }, {
      "name": "Uttarakhand"
    }, {
      "name": "West Bengal"
    }],
    "name": "India"
  },
  "Indonesia": {
    "states": [],
    "name": "Indonesia"
  },
  "Iran, Islamic Republic of": {
    "states": [],
    "name": "Iran, Islamic Republic of"
  },
  "Iraq": {
    "states": [],
    "name": "Iraq"
  },
  "Ireland": {
    "states": [{
      "name": "Clare"
    }, {
      "name": "Cavan"
    }, {
      "name": "Cork"
    }, {
      "name": "Carlow"
    }, {
      "name": "Dublin"
    }, {
      "name": "Donegal"
    }, {
      "name": "Galway"
    }, {
      "name": "Kildare"
    }, {
      "name": "Kilkenny"
    }, {
      "name": "Kerry"
    }, {
      "name": "Longford"
    }, {
      "name": "Louth"
    }, {
      "name": "Limerick"
    }, {
      "name": "Leitrim"
    }, {
      "name": "Laois"
    }, {
      "name": "Meath"
    }, {
      "name": "Monaghan"
    }, {
      "name": "Mayo"
    }, {
      "name": "Offaly"
    }, {
      "name": "Roscommon"
    }, {
      "name": "Sligo"
    }, {
      "name": "Tipperary"
    }, {
      "name": "Waterford"
    }, {
      "name": "Westmeath"
    }, {
      "name": "Wicklow"
    }, {
      "name": "Wexford"
    }],
    "name": "Ireland"
  },
  "Isle of Man": {
    "states": [],
    "name": "Isle of Man"
  },
  "Israel": {
    "states": [],
    "name": "Israel"
  },
  "Italy": {
    "states": [{
      "name": "Agrigento"
    }, {
      "name": "Alessandria"
    }, {
      "name": "Ancona"
    }, {
      "name": "Aosta"
    }, {
      "name": "Ascoli Piceno"
    }, {
      "name": "L'Aquila"
    }, {
      "name": "Arezzo"
    }, {
      "name": "Asti"
    }, {
      "name": "Avellino"
    }, {
      "name": "Bari"
    }, {
      "name": "Bergamo"
    }, {
      "name": "Biella"
    }, {
      "name": "Belluno"
    }, {
      "name": "Benevento"
    }, {
      "name": "Bologna"
    }, {
      "name": "Brindisi"
    }, {
      "name": "Brescia"
    }, {
      "name": "Barletta-Andria-Trani"
    }, {
      "name": "Bolzano"
    }, {
      "name": "Cagliari"
    }, {
      "name": "Campobasso"
    }, {
      "name": "Caserta"
    }, {
      "name": "Chieti"
    }, {
      "name": "Carbonia-Iglesias"
    }, {
      "name": "Caltanissetta"
    }, {
      "name": "Cuneo"
    }, {
      "name": "Como"
    }, {
      "name": "Cremona"
    }, {
      "name": "Cosenza"
    }, {
      "name": "Catania"
    }, {
      "name": "Catanzaro"
    }, {
      "name": "Enna"
    }, {
      "name": "Forl\u00ec-Cesena"
    }, {
      "name": "Ferrara"
    }, {
      "name": "Foggia"
    }, {
      "name": "Florence"
    }, {
      "name": "Fermo"
    }, {
      "name": "Frosinone"
    }, {
      "name": "Genoa"
    }, {
      "name": "Gorizia"
    }, {
      "name": "Grosseto"
    }, {
      "name": "Imperia"
    }, {
      "name": "Isernia"
    }, {
      "name": "Crotone"
    }, {
      "name": "Lecco"
    }, {
      "name": "Lecce"
    }, {
      "name": "Livorno"
    }, {
      "name": "Lodi"
    }, {
      "name": "Latina"
    }, {
      "name": "Lucca"
    }, {
      "name": "Monza and Brianza"
    }, {
      "name": "Macerata"
    }, {
      "name": "Messina"
    }, {
      "name": "Milan"
    }, {
      "name": "Mantua"
    }, {
      "name": "Modena"
    }, {
      "name": "Massa and Carrara"
    }, {
      "name": "Matera"
    }, {
      "name": "Naples"
    }, {
      "name": "Novara"
    }, {
      "name": "Nuoro"
    }, {
      "name": "Ogliastra"
    }, {
      "name": "Oristano"
    }, {
      "name": "Olbia-Tempio"
    }, {
      "name": "Palermo"
    }, {
      "name": "Piacenza"
    }, {
      "name": "Padua"
    }, {
      "name": "Pescara"
    }, {
      "name": "Perugia"
    }, {
      "name": "Pisa"
    }, {
      "name": "Pordenone"
    }, {
      "name": "Prato"
    }, {
      "name": "Parma"
    }, {
      "name": "Pistoia"
    }, {
      "name": "Pesaro and Urbino"
    }, {
      "name": "Pavia"
    }, {
      "name": "Potenza"
    }, {
      "name": "Ravenna"
    }, {
      "name": "Reggio Calabria"
    }, {
      "name": "Reggio Emilia"
    }, {
      "name": "Ragusa"
    }, {
      "name": "Rieti"
    }, {
      "name": "Rome"
    }, {
      "name": "Rimini"
    }, {
      "name": "Rovigo"
    }, {
      "name": "Salerno"
    }, {
      "name": "Siena"
    }, {
      "name": "Sondrio"
    }, {
      "name": "La Spezia"
    }, {
      "name": "Syracuse"
    }, {
      "name": "Sassari"
    }, {
      "name": "Savona"
    }, {
      "name": "Taranto"
    }, {
      "name": "Teramo"
    }, {
      "name": "Trento"
    }, {
      "name": "Turin"
    }, {
      "name": "Trapani"
    }, {
      "name": "Terni"
    }, {
      "name": "Trieste"
    }, {
      "name": "Treviso"
    }, {
      "name": "Udine"
    }, {
      "name": "Varese"
    }, {
      "name": "Verbano-Cusio-Ossola"
    }, {
      "name": "Vercelli"
    }, {
      "name": "Venice"
    }, {
      "name": "Vicenza"
    }, {
      "name": "Verona"
    }, {
      "name": "Medio Campidano"
    }, {
      "name": "Viterbo"
    }, {
      "name": "Vibo Valentia"
    }],
    "name": "Italy"
  },
  "Jamaica": {
    "states": [],
    "name": "Jamaica"
  },
  "Japan": {
    "states": [],
    "name": "Japan"
  },
  "Jersey": {
    "states": [],
    "name": "Jersey"
  },
  "Jordan": {
    "states": [],
    "name": "Jordan"
  },
  "Kazakhstan": {
    "states": [],
    "name": "Kazakhstan"
  },
  "Kenya": {
    "states": [],
    "name": "Kenya"
  },
  "Kiribati": {
    "states": [],
    "name": "Kiribati"
  },
  "Korea, Democratic People's Republic of": {
    "states": [],
    "name": "Korea, Democratic People's Republic of"
  },
  "Korea, Republic of": {
    "states": [],
    "name": "Korea, Republic of"
  },
  "Kuwait": {
    "states": [],
    "name": "Kuwait"
  },
  "Kyrgyzstan": {
    "states": [],
    "name": "Kyrgyzstan"
  },
  "Lao People's Democratic Republic": {
    "states": [],
    "name": "Lao People's Democratic Republic"
  },
  "Latvia": {
    "states": [],
    "name": "Latvia"
  },
  "Lebanon": {
    "states": [],
    "name": "Lebanon"
  },
  "Lesotho": {
    "states": [],
    "name": "Lesotho"
  },
  "Liberia": {
    "states": [],
    "name": "Liberia"
  },
  "Libya": {
    "states": [],
    "name": "Libya"
  },
  "Liechtenstein": {
    "states": [],
    "name": "Liechtenstein"
  },
  "Lithuania": {
    "states": [],
    "name": "Lithuania"
  },
  "Luxembourg": {
    "states": [],
    "name": "Luxembourg"
  },
  "Macao": {
    "states": [],
    "name": "Macao"
  },
  "Macedonia, the former Yugoslav Republic of": {
    "states": [],
    "name": "Macedonia, the former Yugoslav Republic of"
  },
  "Madagascar": {
    "states": [],
    "name": "Madagascar"
  },
  "Malawi": {
    "states": [],
    "name": "Malawi"
  },
  "Malaysia": {
    "states": [],
    "name": "Malaysia"
  },
  "Maldives": {
    "states": [],
    "name": "Maldives"
  },
  "Mali": {
    "states": [],
    "name": "Mali"
  },
  "Malta": {
    "states": [],
    "name": "Malta"
  },
  "Martinique": {
    "states": [],
    "name": "Martinique"
  },
  "Mauritania": {
    "states": [],
    "name": "Mauritania"
  },
  "Mauritius": {
    "states": [],
    "name": "Mauritius"
  },
  "Mayotte": {
    "states": [],
    "name": "Mayotte"
  },
  "Mexico": {
    "states": [{
      "name": "Aguascalientes"
    }, {
      "name": "Baja California"
    }, {
      "name": "Baja California Sur"
    }, {
      "name": "Chihuahua"
    }, {
      "name": "Colima"
    }, {
      "name": "Campeche"
    }, {
      "name": "Coahuila"
    }, {
      "name": "Chiapas"
    }, {
      "name": "Federal District"
    }, {
      "name": "Durango"
    }, {
      "name": "Guerrero"
    }, {
      "name": "Guanajuato"
    }, {
      "name": "Hidalgo"
    }, {
      "name": "Jalisco"
    }, {
      "name": "Mexico State"
    }, {
      "name": "Michoac\u00e1n"
    }, {
      "name": "Morelos"
    }, {
      "name": "Nayarit"
    }, {
      "name": "Nuevo Le\u00f3n"
    }, {
      "name": "Oaxaca"
    }, {
      "name": "Puebla"
    }, {
      "name": "Quer\u00e9taro"
    }, {
      "name": "Quintana Roo"
    }, {
      "name": "Sinaloa"
    }, {
      "name": "San Luis Potos\u00ed"
    }, {
      "name": "Sonora"
    }, {
      "name": "Tabasco"
    }, {
      "name": "Tlaxcala"
    }, {
      "name": "Tamaulipas"
    }, {
      "name": "Veracruz"
    }, {
      "name": "Yucat\u00e1n"
    }, {
      "name": "Zacatecas"
    }],
    "name": "Mexico"
  },
  "Moldova, Republic of": {
    "states": [],
    "name": "Moldova, Republic of"
  },
  "Monaco": {
    "states": [],
    "name": "Monaco"
  },
  "Mongolia": {
    "states": [],
    "name": "Mongolia"
  },
  "Montenegro": {
    "states": [],
    "name": "Montenegro"
  },
  "Montserrat": {
    "states": [],
    "name": "Montserrat"
  },
  "Morocco": {
    "states": [],
    "name": "Morocco"
  },
  "Mozambique": {
    "states": [],
    "name": "Mozambique"
  },
  "Myanmar": {
    "states": [],
    "name": "Myanmar"
  },
  "Namibia": {
    "states": [],
    "name": "Namibia"
  },
  "Nauru": {
    "states": [],
    "name": "Nauru"
  },
  "Nepal": {
    "states": [],
    "name": "Nepal"
  },
  "Netherlands": {
    "states": [],
    "name": "Netherlands"
  },
  "New Caledonia": {
    "states": [],
    "name": "New Caledonia"
  },
  "New Zealand": {
    "states": [],
    "name": "New Zealand"
  },
  "Nicaragua": {
    "states": [],
    "name": "Nicaragua"
  },
  "Niger": {
    "states": [],
    "name": "Niger"
  },
  "Nigeria": {
    "states": [],
    "name": "Nigeria"
  },
  "Niue": {
    "states": [],
    "name": "Niue"
  },
  "Norfolk Island": {
    "states": [],
    "name": "Norfolk Island"
  },
  "Norway": {
    "states": [],
    "name": "Norway"
  },
  "Oman": {
    "states": [],
    "name": "Oman"
  },
  "Pakistan": {
    "states": [],
    "name": "Pakistan"
  },
  "Palestine": {
    "states": [],
    "name": "Palestine"
  },
  "Panama": {
    "states": [],
    "name": "Panama"
  },
  "Papua New Guinea": {
    "states": [],
    "name": "Papua New Guinea"
  },
  "Paraguay": {
    "states": [],
    "name": "Paraguay"
  },
  "Peru": {
    "states": [],
    "name": "Peru"
  },
  "Philippines": {
    "states": [],
    "name": "Philippines"
  },
  "Pitcairn": {
    "states": [],
    "name": "Pitcairn"
  },
  "Poland": {
    "states": [],
    "name": "Poland"
  },
  "Portugal": {
    "states": [],
    "name": "Portugal"
  },
  "Qatar": {
    "states": [],
    "name": "Qatar"
  },
  "Reunion": {
    "states": [],
    "name": "Reunion"
  },
  "Romania": {
    "states": [],
    "name": "Romania"
  },
  "Russian Federation": {
    "states": [],
    "name": "Russian Federation"
  },
  "Rwanda": {
    "states": [],
    "name": "Rwanda"
  },
  "Saint Barth\u00e9lemy": {
    "states": [],
    "name": "Saint Barth\u00e9lemy"
  },
  "Saint Helena, Ascension and Tristan da Cunha": {
    "states": [],
    "name": "Saint Helena, Ascension and Tristan da Cunha"
  },
  "Saint Kitts and Nevis": {
    "states": [],
    "name": "Saint Kitts and Nevis"
  },
  "Saint Lucia": {
    "states": [],
    "name": "Saint Lucia"
  },
  "Saint Martin (French part)": {
    "states": [],
    "name": "Saint Martin (French part)"
  },
  "Saint Pierre and Miquelon": {
    "states": [],
    "name": "Saint Pierre and Miquelon"
  },
  "Saint Vincent and the Grenadines": {
    "states": [],
    "name": "Saint Vincent and the Grenadines"
  },
  "Samoa": {
    "states": [],
    "name": "Samoa"
  },
  "San Marino": {
    "states": [],
    "name": "San Marino"
  },
  "Sao Tome and Principe": {
    "states": [],
    "name": "Sao Tome and Principe"
  },
  "Saudi Arabia": {
    "states": [],
    "name": "Saudi Arabia"
  },
  "Senegal": {
    "states": [],
    "name": "Senegal"
  },
  "Serbia": {
    "states": [],
    "name": "Serbia"
  },
  "Seychelles": {
    "states": [],
    "name": "Seychelles"
  },
  "Sierra Leone": {
    "states": [],
    "name": "Sierra Leone"
  },
  "Singapore": {
    "states": [],
    "name": "Singapore"
  },
  "Sint Maarten (Dutch part)": {
    "states": [],
    "name": "Sint Maarten (Dutch part)"
  },
  "Slovakia": {
    "states": [],
    "name": "Slovakia"
  },
  "Slovenia": {
    "states": [],
    "name": "Slovenia"
  },
  "Solomon Islands": {
    "states": [],
    "name": "Solomon Islands"
  },
  "Somalia": {
    "states": [],
    "name": "Somalia"
  },
  "South Africa": {
    "states": [],
    "name": "South Africa"
  },
  "South Georgia and the South Sandwich Islands": {
    "states": [],
    "name": "South Georgia and the South Sandwich Islands"
  },
  "South Sudan": {
    "states": [],
    "name": "South Sudan"
  },
  "Spain": {
    "states": [],
    "name": "Spain"
  },
  "Sri Lanka": {
    "states": [],
    "name": "Sri Lanka"
  },
  "Sudan": {
    "states": [],
    "name": "Sudan"
  },
  "Suriname": {
    "states": [],
    "name": "Suriname"
  },
  "Svalbard and Jan Mayen": {
    "states": [],
    "name": "Svalbard and Jan Mayen"
  },
  "Swaziland": {
    "states": [],
    "name": "Swaziland"
  },
  "Sweden": {
    "states": [],
    "name": "Sweden"
  },
  "Switzerland": {
    "states": [],
    "name": "Switzerland"
  },
  "Syrian Arab Republic": {
    "states": [],
    "name": "Syrian Arab Republic"
  },
  "Taiwan": {
    "states": [],
    "name": "Taiwan"
  },
  "Tajikistan": {
    "states": [],
    "name": "Tajikistan"
  },
  "Tanzania, United Republic of": {
    "states": [],
    "name": "Tanzania, United Republic of"
  },
  "Thailand": {
    "states": [],
    "name": "Thailand"
  },
  "Timor-Leste": {
    "states": [],
    "name": "Timor-Leste"
  },
  "Togo": {
    "states": [],
    "name": "Togo"
  },
  "Tokelau": {
    "states": [],
    "name": "Tokelau"
  },
  "Tonga": {
    "states": [],
    "name": "Tonga"
  },
  "Trinidad and Tobago": {
    "states": [],
    "name": "Trinidad and Tobago"
  },
  "Tunisia": {
    "states": [],
    "name": "Tunisia"
  },
  "Turkey": {
    "states": [],
    "name": "Turkey"
  },
  "Turkmenistan": {
    "states": [],
    "name": "Turkmenistan"
  },
  "Turks and Caicos Islands": {
    "states": [],
    "name": "Turks and Caicos Islands"
  },
  "Tuvalu": {
    "states": [],
    "name": "Tuvalu"
  },
  "Uganda": {
    "states": [],
    "name": "Uganda"
  },
  "Ukraine": {
    "states": [],
    "name": "Ukraine"
  },
  "United Arab Emirates": {
    "states": [],
    "name": "United Arab Emirates"
  },
  "United Kingdom": {
    "states": [],
    "name": "United Kingdom"
  },
  
  "Uruguay": {
    "states": [],
    "name": "Uruguay"
  },
  "Uzbekistan": {
    "states": [],
    "name": "Uzbekistan"
  },
  "Vanuatu": {
    "states": [],
    "name": "Vanuatu"
  },
  "Venezuela, Bolivarian Republic of": {
    "states": [],
    "name": "Venezuela, Bolivarian Republic of"
  },
  "Vietnam": {
    "states": [],
    "name": "Vietnam"
  },
  "Virgin Islands, British": {
    "states": [],
    "name": "Virgin Islands, British"
  },
  "Wallis and Futuna": {
    "states": [],
    "name": "Wallis and Futuna"
  },
  "Western Sahara": {
    "states": [],
    "name": "Western Sahara"
  },
  "Yemen": {
    "states": [],
    "name": "Yemen"
  },
  "Zambia": {
    "states": [],
    "name": "Zambia"
  },
  "Zimbabwe": {
    "states": [],
    "name": "Zimbabwe"
  }
}


export default countriesObj



// WEBPACK FOOTER //
// ./src/components/countries.js